"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hostname = void 0;
const authLocation = () => {
    if (window.location.hostname === "localhost") {
        return window.location.hostname.includes("localtls.kvix")
            ? `https://${window.location.hostname}:8080`
            : `http://${window.location.hostname}:8080`;
    }
    return window.location.origin;
};
const auth = {
    register: () => authLocation(),
    signin: () => authLocation(),
    signout: () => authLocation(),
};
const socket = {
    default() {
        const { protocol, hostname } = window.location;
        if (process.env.NODE_ENV === "development") {
            const port = process.env.REACT_APP_DEVELOPMENT_SOCKET_PORT;
            return `${protocol}//${hostname}:${port}`;
        }
        return `${protocol}//${hostname}`;
    },
};
const recorder = {
    default() {
        const host = process.env.NODE_ENV === "development" ? "localhost:9090" : "recorder";
        return `http://${host}`;
    },
};
const client = {
    default() {
        if (process.env.NODE_ENV !== "development") {
            return `https://${process.env.DOMAIN_NAME}`;
        }
        const host = process.env.DOMAIN_NAME ||
            process.env.REACT_APP_LOCALTLS_IP ||
            process.env.REACT_NATIVE_LOCALTLS_IP;
        return `http://${host}:3000`;
    },
};
const campaignUrl = {
    getUrl(props) {
        if (window.location.host === "localhost:5000") {
            props(`http://${window.location.hostname}:3000`);
        }
        else if (window.location.host === "admin.kvix.se") {
            props(`https://kvix.se`);
        }
        else if (window.location.host === "admin.test.kvix.se") {
            props(`https://test.kvix.se`);
        }
        else if (window.location.host === "admin.stage.kvix.se") {
            props(`https://stage.kvix.se`);
        }
        else if (window.location.host === "admin.kvix.dev") {
            props(`https://kvix.dev`);
        }
        else if (window.location.host === "admin.kvix.tv") {
            props(`https://kvix.tv`);
        }
    },
};
exports.Hostname = {
    auth,
    client,
    socket,
    recorder,
    campaignUrl,
};
//# sourceMappingURL=hostname.js.map